<template>
	<UserRegistrationFullScreenLayout>
		<div class="page-title">What would you like to call your workspace?</div>
		<v-form v-model="isFormValid" ref="setWorkspaceForm" @submit.prevent="submitForm" class="form-section">
			<SignupTextField
				label=""
				iconName="workspace"
				:rules="nameRules"
				v-model="workspaceName"
				type="email"
				autofocus
				single-line
				placeholder="My Workspace"
			/>
			<div class="organization-auto-join-row flex-centerize flex-row">
				<v-checkbox hide-details single-line v-model="allowAutoJoin">
					<template v-slot:label>
						<div class="organiztion-privacy-text flex-centerize flex-start--center">
							Allow users within the domain to join automatically
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" class="check-mark-button flex-centerize">
										<SIcon name="checkmark" />
									</v-btn>
								</template>
								<div class="tooltip-text">
									New users will be added as org members.<br />They will not get access to any of your data<br />unless you share it or give
									them a role with <br />permissions to access it.
								</div>
							</v-tooltip>
						</div>
					</template>
				</v-checkbox>
			</div>
			<v-btn :loading="submitting" color="primary" type="submit">Next</v-btn>
			<div v-if="showError" class="error-text">An error occured, couldn't update your workspace settings. Please try again</div>
		</v-form>
	</UserRegistrationFullScreenLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SignupTextField from './components/SignupTextField';
import UserRegistrationFullScreenLayout from './UserRegistrationFullScreenLayout.vue';

import UserRegistrationService from './helpers/UserRegistrationService';

import UserRegistrationMixin from './helpers/UserRegistrationMixin';
import AnalyticsService from '@/utils/AnalyticsService';

export default {
	name: 'SetWorkspaceName',
	components: {
		UserRegistrationFullScreenLayout,
		SignupTextField,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		...mapGetters(['user']),
	},
	methods: {
		...mapActions(['getUser']),
		...mapActions('account', ['updateAccount']),
		async submitForm() {
			this.showError = false;
			const { signup_referrer } = this.user.profile.metadata;

			this.$refs.setWorkspaceForm.validate();
			if (this.isFormValid) {
				this.submitting = true;
				try {
					await this.updateAccount({ name: this.workspaceName, allow_auto_join: this.allowAutoJoin });
					AnalyticsService.updateUserProps({ workspaceName: this.workspaceName });
					const navigateTo = await UserRegistrationService.getNavigateToFirstPageObject(signup_referrer, this.$route.query.return_to);
					this.navigateTo(navigateTo);
				} catch {
					this.showError = true;
				}
				this.submittingForm = false;
			}
			return;
		},
	},
	data: () => ({
		showError: false,
		workspaceName: '',
		submitting: false,
		isFormValid: false,
		allowAutoJoin: false,
		nameRules: UserRegistrationService.getNameRules(),
	}),
};
</script>

<style scoped lang="scss">
.organization-auto-join-row {
	margin-left: 100px;
}
.v-tooltip__content {
	opacity: 1 !important;
	padding: 6px 5px !important;
	color: var(--bg-color) !important;
	background-color: #333333 !important;
}
.v-tooltip__content:after {
	left: 0;
	right: 0;
	margin-left: auto;
	margin-right: auto;
	width: 0 !important;
	height: 0 !important;
	opacity: 1 !important;
	content: '' !important;
	bottom: -5px !important;
	position: absolute !important;
	border-left: 5px solid transparent !important;
	border-right: 5px solid transparent !important;
	border-top: 5px solid #333333 !important;
}

.check-mark-button {
	height: 21px !important;
	width: 19px !important;
	padding: 0px !important;
	margin-top: 2px !important;
	margin-left: 10px !important;
}

.tooltip-text {
	font-size: 12px;
	text-align: left;
}

.organiztion-privacy-text {
	font-size: 16px;
	color: var(--primary-font-color);
}

.error-text {
	color: red;
	font-size: 14px;
	margin-top: 20px;
}
</style>
